/* eslint-disable */
import React, { Component, PropTypes  } from 'react';
//import logo from './logo.svg';
//import './App.css';
import Header from './components/Header'
var Footer = require('./components/Footer')
var {Router,
      Route,
      IndexRoute,
      IndexLink,
      Link } = require('react-router');
      import Alert from 'react-s-alert';
      
      import 'react-s-alert/dist/s-alert-default.css';
      import 'react-s-alert/dist/s-alert-css-effects/slide.css';


//var RouteHandler = require('react-router').RouteHandler;

class App extends Component {
    constructor(props, context) {
    super(props, context);

  }

  render() {
    return (
      <div>
      <Header />
      <div className="App">
      {this.props.children}    
      </div>
      <Alert stack={{limit: 3}} />
            <Footer />
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/